import React from 'react';
import { TranslateScope } from '@pegasus/translation';
import { useConfig } from '@browsing/config';

import { ShutdownMessage } from './shutdown-message';

export const Error = () => {
    const config = useConfig();

    const showShutdownMessage = config.isEnabled('shutdown');
    // TODO: get designs for regular error page

    return (
        <>
            {showShutdownMessage ? (
                <TranslateScope path="myLounge.shutdown">
                    <ShutdownMessage />
                </TranslateScope>
            ) : (
                <div>Error</div>
            )}
        </>
    );
};
